/**
 * System Settings Page
 * Mem0 config, First Message config, Agent Export/Import
 */

import { useState } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/Tabs';
import {
  Mem0ConfigPanel,
  SessionSummaryConfigPanel,
  HtmlPageSettingsTab,
  FirstMessagePanel,
  AgentConfigsExportImport,
  ModelDefaultsPanel,
} from '@/features/system-settings';
import { Brain, MessageSquare, ArrowUpDown, Cpu, FileText, Globe } from 'lucide-react';
import { useI18n } from '@/i18n';

export function SystemSettingsPage() {
  const { messages } = useI18n();
  const t = messages.systemSettings;
  const [activeTab, setActiveTab] = useState('model-defaults');

  return (
    <div className="p-6 max-w-7xl mx-auto">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">{t.pageTitle}</h1>
          <p className="text-gray-600 mt-1">
            {t.pageDescription}
          </p>
        </div>

        <Tabs value={activeTab} onValueChange={setActiveTab}>
          <TabsList className="mb-6">
            <TabsTrigger value="model-defaults" className="flex items-center gap-2">
              <Cpu className="w-4 h-4" />
              {t.tabs.modelDefaults || 'Model Defaults'}
            </TabsTrigger>
            <TabsTrigger value="mem0" className="flex items-center gap-2">
              <Brain className="w-4 h-4" />
              {t.tabs.mem0Config}
            </TabsTrigger>
            <TabsTrigger value="session-summary" className="flex items-center gap-2">
              <FileText className="w-4 h-4" />
              话题压缩
            </TabsTrigger>
            <TabsTrigger value="html-page" className="flex items-center gap-2">
              <Globe className="w-4 h-4" />
              {t.tabs.htmlPage || 'HTML 页面'}
            </TabsTrigger>
            <TabsTrigger value="first-message" className="flex items-center gap-2">
              <MessageSquare className="w-4 h-4" />
              {t.tabs.firstMessage}
            </TabsTrigger>
            <TabsTrigger value="export-import" className="flex items-center gap-2">
              <ArrowUpDown className="w-4 h-4" />
              {t.tabs.exportImport}
            </TabsTrigger>
          </TabsList>

          <TabsContent value="model-defaults">
            <ModelDefaultsPanel />
          </TabsContent>

          <TabsContent value="mem0">
            <Mem0ConfigPanel />
          </TabsContent>

          <TabsContent value="session-summary">
            <SessionSummaryConfigPanel />
          </TabsContent>

          <TabsContent value="html-page">
            <HtmlPageSettingsTab />
          </TabsContent>

          <TabsContent value="first-message">
            <FirstMessagePanel />
          </TabsContent>

          <TabsContent value="export-import">
            <AgentConfigsExportImport />
          </TabsContent>
        </Tabs>
    </div>
  );
}
